import * as React from "react";
const SvgGridAdd20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 2h16v8h-7v6H1V2Zm7 12v-4H3v4h5ZM3 8h5V4H3v4Zm7-4v4h5V4h-5Zm5 12h-3v-2h3v-3h2v3h3v2h-3v3h-2v-3Z",
      clipRule: "evenodd"
    })
  );
export default SvgGridAdd20Px;
